/**
 * Skeleton loaders estilo Apple para listados y tarjetas mientras
 * cargan datos. La animación shimmer se define en index.css como
 * `.apple-skeleton`.
 */

export function Skeleton({ w = "100%", h = 12, className = "", style = {} }) {
  return (
    <span
      className={`apple-skeleton ${className}`}
      style={{ width: w, height: h, ...style }}
      data-testid="skeleton-bar"
    />
  );
}

/** Fila de tabla estilo Pacientes (avatar + 2 líneas + 3 columnas + botón) */
export function TableRowSkeleton() {
  return (
    <div
      className="grid grid-cols-[auto_1fr_1fr_1fr_1fr_auto] items-center gap-4 px-4 py-3.5 border-b border-black/[0.04]"
      data-testid="skeleton-row"
    >
      <span className="apple-skeleton w-9 h-9 rounded-full" />
      <div className="flex flex-col gap-1.5">
        <Skeleton w={140} h={12} />
        <Skeleton w={90} h={10} />
      </div>
      <Skeleton w={110} h={12} />
      <Skeleton w={100} h={12} />
      <Skeleton w={90} h={12} />
      <span className="apple-skeleton w-20 h-8 rounded-full" />
    </div>
  );
}

/** Grupo de N filas de tabla — útil como fallback de listados. */
export function TableSkeleton({ rows = 6 }) {
  return (
    <div data-testid="skeleton-table">
      {Array.from({ length: rows }).map((_, i) => (
        <TableRowSkeleton key={i} />
      ))}
    </div>
  );
}

/** Tarjeta KPI skeleton — mimica el nuevo AppleKpi (fondo F5F5F7, altura expandida). */
export function KpiSkeleton() {
  return (
    <div
      className="rounded-[22px] bg-[#F5F5F7] p-5 flex flex-col min-h-[180px]"
      data-testid="skeleton-kpi"
    >
      <div className="flex items-center gap-2">
        <span className="apple-skeleton w-[18px] h-[18px] rounded" />
        <Skeleton w={120} h={14} />
      </div>
      <div className="mt-2">
        <Skeleton w={200} h={11} />
        <div className="mt-1">
          <Skeleton w={160} h={11} />
        </div>
      </div>
      <div className="mt-3">
        <Skeleton w={70} h={11} />
        <div className="mt-1.5">
          <Skeleton w={90} h={24} />
        </div>
      </div>
      <div className="mt-4 pt-3 border-t border-black/[0.08]">
        <Skeleton w={140} h={11} />
      </div>
    </div>
  );
}
